<template>
  <div :class="rootClass">
    <b-row>
      <b-col cols="12">
        <b-row class="mb-2">
          <b-col lg="3" sm="12">
            <b-row align-v="center">
              <label :class="rootClass + '__phone-number-label'"
              >Số CCND/CCCD</label
              >
              <b-form-input
                  ref="inputSearchPhone"
                  v-model="noNumberSearch"
                  :class="rootClass + '__phone-number-input'"
                  type="number"
                  v-on:keyup.enter="getMsindn"
              ></b-form-input>
            </b-row>
          </b-col>
          <b-col lg="2" sm="12" style="display: flex; align-items: center; max-width: 13%;margin-right: 4%">
            <b-button
                :class="rootClass + '__search-voice-sms-data-btn'"
                class="redButton"
                style="margin-left: -30%"
                variant="danger"
                @click="getMsindn()"
            >Tra cứu
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <table :class="rootClass + '__history-voice-sms-data-table'">
            <tr style="height: 3rem">
              <template v-for="(h, i) in historyVoiceSMSDataTable.fields"
              >
                <th
                    :key="h.key"
                    :class="{
                          '--first-th': i === 0,
                          '--last-th':
                            i === historyVoiceSMSDataTable.fields.length - 1,
                        }"
                >
                  {{ h.label }}
                </th>
              </template
              >
            </tr>
            <template v-for="(i,index) in misndnResult">
              <tr v-if="showErrSearch===false" style="color:black;">
                <td>{{ index + 1 }}</td>
                <td>{{ listTTTB[index].IDNUMBER }}</td>
                <td>{{ listTTTB[index].IDNUMBERTYPE }}</td>
                <td class="clickableButton" @click="searchTTTB(i)">{{ i }}</td>
                <td>{{ listTTTB[index].FULLNAME }}</td>
                <td>{{ listTTTB[index].BIRTHDAY }}</td>
                <td>{{ listTTTB[index].ADDRESS }}</td>
                <td>{{ listTTTB[index].PLACEDATE }}</td>
                <td>{{ listTTTB[index].PLACEOFISSUE }}</td>
                <td>{{ listKDK[index].methodName }}</td>
                <td>{{ listTTTB[index].REGISTERDATE }}</td>
                <td>{{ listKDK[index].username }}</td>
              </tr>
            </template>
          </table>
        </b-row>
        <b-row v-if="showErrSearch" style="justify-content: center;font-size: 18px">
          Không tìm thấy kết quả!
        </b-row>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import DropMenu from "./DropMenu.vue";
import useJwt from "@/auth/jwt/useJwt";

export default {
  name: "NoNumberToMsindn",
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BModal,
    BFormGroup,
    BFormCheckbox,
    BImg,
    BButtonGroup,
    BInputGroup,
    BInputGroupPrepend,
    BTabs,
    BTab,
    BContainer,
    BFormDatepicker,
    DropMenu,
  },
  data() {
    return {
      rootClass: "search-crs",
      historyVoiceSMSDataTable: {
        fields: [
          {key: "stt", label: "STT"},
          {key: "noNumber", label: "Số giấy tờ"},
          {key: "cardType", label: "Loại giấy tờ"},
          {key: "phone", label: "Số thuê bao"},
          {key: "name", label: "Họ và tên"},
          {key: "dob", label: "Ngày sinh"},
          {key: "Address", label: "Địa chỉ"},
          {key: "issueDate", label: "Ngày cấp"},
          {key: "issueBy", label: "Nơi cấp"},
          {key: "impactChannel", label: "Kênh tác động"},
          {key: "impactTime", label: "Ngày đăng ký"},
          {key: "impactUser", label: "Người dùng tác động"},
        ]
      },
      CdrDetail: [],
      regex087: /87\d{7}$/,
      misndnResult: [],
      listTTTB: [],
      listKDK: [],
      showErrSearch: false,
    };
  },
  props: {
    noNumberSearch: String
  },
  mounted() {
    this.$root.$on("bv::dropdown::show", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = true;
      }
    });
    this.$root.$on("bv::dropdown::hide", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = false;
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault();
      }
    });
    if (this.noNumberSearch.length > 0) {
      this.getMsindn()
    }
  },
  computed: {},
  methods: {
    getMsindn() {
      this.showLoading("block")
      this.listTTTB = []
      useJwt.get('get_msisdn_from/' + this.noNumberSearch).then((response) => {
        this.showLoading("none")
        this.misndnResult = response.data.result.result;
        this.misndnResult.forEach((e) => {
          this.getTTTB(e)
          this.getRegisterMethod(e)
        })
        this.showErrSearch = false
        console.log("msisdn", this.misndnResult);
      }).catch((error) => {
        this.showLoading("none")
        this.misndnResult = ""
        this.showErrSearch = true
        console.log(error);
      });
    },
    showLoading(options) {
      document.getElementById('loading-bg').style.display = options;
    },
    getTTTB(searchPhone) {
      useJwt.get('search_pps_info/' + searchPhone).then((response) => {
        this.listTTTB.push(response.data.result);
        console.log("TTTB", this.listTTTB)
      }).catch((error) => {
        this.listTTTB = []
        this.isShowErrNoti = true
      });
    },
    getRegisterMethod(searchPhone) {
      useJwt.get('get-register-method/' + searchPhone).then((response) => {
        this.listKDK.push(response.data.result.result);
        console.log("getRegisterMethod", response.data);
      }).catch((error) => {
        console.log(error);
      });
    },
    formatPhoneNum(phone) {
      if (phone.startsWith("84")) {
        phone = phone.substring(2);
        phone = "0" + phone;
      }
      console.log("phone", phone)
      return phone;
    },
    searchTTTB(phone) {
      let tab = {value: "SubscriberInformation", text: "Thông tin thuê bao"}
      this.$emit('searchTTTB', {searchPhoneNumberEmit: this.formatPhoneNum(phone), openTab: tab})

    },
  }
}
</script>

<style lang="scss" scoped>
.search-crs {
  position: relative;
  font-size: 16px;
  font-family: "Times New Roman";
  min-height: 500px;

  &__card {
    border-radius: 2rem;
    background: #fcfcfc;
  }

  &__func-group-btns {
    border: 1px solid red;
    border-radius: 40px;
    height: 38px;
  }

  &__subscriber-information-btn {
    border-radius: 40px;
    font-weight: 800;
    color: #707070 !important;
    background: transparent !important;
    border: transparent;
    padding: 0.2rem 1.5rem;
  }

  &__search-crs-btn {
    border-radius: 40px !important;
    color: white;
    width: 195px;
    padding: 0.2rem 1.5rem;
  }

  &__phone-number-label {
    font-weight: 500;
    color: black;
    font-size: 12px;
    margin-right: 0.3rem;
    width: 100px;
  }

  &__phone-number-input {
    width: 200px;
  }

  &__from-date-label {
    font-weight: 500;
    color: black;
    font-size: 12px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__from-date-input {
    width: 200px;
  }

  &__to-date-label {
    font-weight: 500;
    color: black;
    font-size: 12px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__to-date-input {
    width: 200px;
  }

  &__search-voice-sms-data-btn {
    border-radius: 40px;
    //font-size: 10px;
  }

  &__history-voice-sms-data-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    .clickableButton {
      cursor: pointer;
      color: #384DC0;
      text-decoration: underline;
    }

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border: 0.299185px solid rgba(184, 184, 184, 0.5);
      padding: 2px;
    }

    th {
      background-color: #ED1F24;
      color: white;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }

  &__export-voice-sms-data-btn {
    border-radius: 40px;
  }

  &__search-spam-btn {
    border-radius: 40px;
    font-size: 10px;
  }

  &__history-spam-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border-right: 0.299185px solid rgba(184, 184, 184, 0.5);
      border-left: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    tr td {
      color: black;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }

  &__menu-right-group {
    position: absolute;
    top: 60px;
    right: 20px;
  }
}

.redButton {
  background-color: #ED1F24 !important;
  border-color: #ED1F24 !important;
}

@media screen and (max-width: 576px) {
  .search-crs {
    &__phone-number-label {
      width: 100%;
    }

    &__phone-number-input {
      width: 100%;
    }

    &__from-date-label {
      width: 100%;
    }

    &__from-date-input {
      width: 100%;
    }

    &__to-date-label {
      width: 100%;
    }

    &__to-date-input {
      width: 100%;
    }
  }
}
</style>
